export type FormMode = 'support' | 'compensation' | '';

export type CreateTicketPayload = FormData & {
  subject: string;
  comment: string;
  files: File[];
  tag: FormMode;
};

export const acceptedFileTypes = [
  '.doc',
  '.docx',
  '.txt',
  '.pdf',
  '.png',
  '.jpeg',
  '.jpg',
  '.zip',
  '.log',
  '.mov',
  '.csv',
  '.xls',
  '.xlsx',
] as const;
